import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=d698cd0e&scoped=true"
import script from "./VideoPage.vue?vue&type=script&lang=js"
export * from "./VideoPage.vue?vue&type=script&lang=js"
import style0 from "./VideoPage.vue?vue&type=style&index=0&id=d698cd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d698cd0e",
  null
  
)

export default component.exports